import React, {memo, useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import TagList from "./tag/TagList";
import {AppState} from "../../../root/RootReducer";
import SlideGroup from "../../../common/components/slide/SlideGroup";
import {
    GetRecVideoList,
    GetNewVideoList,
    GetRecommendProgramList,
    GetRecommendProfessionalList,
    GetVideoListByUser
} from "../../../common/homePage/HomePageActions";
import VerticalList from "../../../common/components/verticalList/verticalList";
import styles from "./HomePage.module.css";
import {motion, AnimatePresence} from "framer-motion";
// 視聴履歴、受講中Program用
import {Program} from "../../../stores/program/model/Program";
import {filterVideoList} from "../../../common/video/VideoActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import classNames from "classnames";
import useResponsive from "../../../common/useResponsive";
import {useQuery} from "@tanstack/react-query";
import {isNil} from "lodash";

function HomePage() {
    const dispatch = useDispatch();

    // ヘッダー
    const {header} = useSelector((state: AppState) => ({
        header: state.header
    }));
    const direction = header.direction === "left" ? -1 : 1;

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
    }));

    // おすすめビデオ
    const {list, videos} = useSelector(
        ({recommendList}: AppState) => recommendList
    );
    const videoIds = useMemo(() => (list.length >= 1 ? list : undefined), [list]);

    // ３行リスト
    const {newVideoList} = useSelector(
        ({recommendList}: AppState) => recommendList
    );
    const {recommendProgramList} = useSelector(
        ({recommendList}: AppState) => recommendList
    );
    const {recommendProfessionalList} = useSelector(
        ({recommendList}: AppState) => recommendList
    );
    // 視聴履歴
    const {userVideos} = useSelector(
        ({recommendList}: AppState) => recommendList
    );
    // プログラム一覧リスト
    // const { programList } = useSelector(({ program }: AppState) => program);

    const {isTablet, isDesktop} = useResponsive();

    // おすすめ系のリクエスト
    useEffect(() => {
        dispatch(GetRecVideoList());
        // dispatch(GetRecommendProgramList());
        dispatch(GetRecommendProfessionalList());
    }, [dispatch]);

    // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //   if (e.key === "Enter") {
    //     // console.log("你按下了回车键，输入的内容是：", ez/value);
    //     // 在这里可以触发提交操作或其他逻辑
    //   }
    // };

    // ログインユーザーの視聴履歴
    const {data:programList = []} = useQuery<Program[]>({
        queryKey:["/api/getLearningProgramVideoList",null,userInfo.id],
        enabled: !isNil(userInfo?.id)
    });
    useEffect(() => {
        const videoFilter = {
            id: [],
            professional: [],
            program: [],
            project: [],
            tag: []
        };
        if (userInfo) {
            dispatch(GetVideoListByUser(userInfo.id));
            dispatch(GetNewVideoList(userInfo.id));
            dispatch(filterVideoList(userInfo.id, videoFilter));
            // dispatch(GetLearningProgram(userInfo.id));
            dispatch(GetRecommendProgramList(userInfo.id));
        }
    }, [dispatch, userInfo]);

    //受講中プログラム（isLearning === true）

    const attendProgram: Program[] =
    programList &&
    programList.filter &&
    programList.filter((row) => {
        return row.isLearning === true;
    });

    return (
    //<Container maxWidth="xl">
        <AnimatePresence mode="wait">
            <div className={styles.tagSearchBox}>
                <div className={styles.tagDiv}>
                    {videoIds && (
                        <TagList videoList={videoIds.map((videoId) => videos[videoId])}/>
                    )}
                </div>
                {/* <div className={styles.searchDiv}>
          <img alt="VideoIcon" src={searchIcon} height="18px" width="18px" />
          <input type="text" onKeyDown={handleKeyDown} />
        </div> */}
            </div>

            <motion.div
                key="KnowledgePlay"
                initial={{x: 300 * direction, opacity: 0.5}}
                animate={{x: 0, opacity: 1}}
                exit={{x: -300 * direction, opacity: 0}}
                className={styles.root}
            >
                {/* おすすめビデオ */}
                {/* <div>
          {videoIds && (
            <ThumbsGallery
              videoList={videoIds.map((videoId) => videos[videoId])}
            />
          )}
        </div> */}
                {/*３行リスト */}
                <div className={styles.recommendVideoList}>
                    {/* 新着ビデオ */}
                    <div
                        className={classNames(
                            styles.videoListItem,
                            styles.videoListItemSpace
                        )}
                    >
                        <VerticalList
                            id="newVideos"
                            itemList={
                                newVideoList && newVideoList.length > 3
                                    ? newVideoList.slice(0, 3)
                                    : newVideoList
                            }
                            title="新着Video"
                            imageShape="square"
                            linkName="view more >"
                            linkUrl="/videos"
                        />
                    </div>
                    {/* おすすめProgram */}
                    <div
                        className={classNames(
                            styles.videoListItem,
                            styles.videoListItemSpace
                        )}
                    >
                        {/* {JSON.stringify(recommendProgramList)}
            {recommendProgramList && recommendProgramList.length > 3
              ? "a"
              : "d"} */}
                        <VerticalList
                            id="recommendPrograms"
                            itemList={
                                recommendProgramList && recommendProgramList.length > 3
                                    ? recommendProgramList.slice(0, 3)
                                    : recommendProgramList
                            }
                            title="おすすめのChannel"
                            imageShape="square"
                            linkName="view more >"
                            linkUrl="../channels"
                        />
                    </div>
                    {/* おすすめProfessional */}
                    <div className={styles.videoListItem}>
                        <VerticalList
                            id="recommendProfessionals"
                            itemList={
                                recommendProfessionalList &&
                recommendProfessionalList.length > 3
                                    ? recommendProfessionalList.slice(0, 3)
                                    : recommendProfessionalList
                            }
                            title="おすすめのPresenter"
                            imageShape="circular"
                            linkName="view more >"
                            linkUrl="../presenter"
                        />
                    </div>
                </div>

                {/* 視聴履歴 */}
                <div className={styles.slideTitle}>
                    <PuiTypography size={isDesktop ? 24 : 16} bold={true}>
            最近の視聴履歴
                    </PuiTypography>
                </div>
                {userVideos.length > 0 && (
                    <div className={styles.slideGroup}>
                        <SlideGroup
                            id="視聴履歴"
                            title="視聴履歴"
                            videoListTransition={userVideos}
                            displayNum={isDesktop ? 4 : isTablet ? 2 : 1}
                            slideBetween={5}
                            needLoop={false}
                        />
                    </div>
                )}

                {/* 受講中Program */}
                <div className={styles.slideTitle}>
                    <PuiTypography size={isDesktop ? 24 : 16} bold={true}>
            受講中Channel
                    </PuiTypography>
                </div>
                {attendProgram && attendProgram.length > 0 && (
                    <div className={styles.slideGroup}>
                        <SlideGroup
                            id="受講プログラム"
                            title="受講中Channel"
                            programList={attendProgram}
                            displayNum={isDesktop ? 4 : isTablet ? 2 : 1}
                            slideBetween={5}
                            needLoop={false}
                        />
                    </div>
                )}
            </motion.div>
        </AnimatePresence>
    //</Container>
    );
}

export default memo(HomePage);
